import PropTypes from 'prop-types';

/**
 * Download Icon Component
 * Renders a download arrow icon (down)
 *
 * @param {string} className - Optional CSS class name
 * @param {number} size - Icon size in pixels (default: 14)
 * @param {function} onClick - Optional click handler
 * @param {function} onKeyDown - Optional keyboard handler
 * @param {number} tabIndex - Optional tab index
 * @param {string} role - Optional ARIA role
 * @param {string} aria-label - Optional ARIA label
 */
export default function DownloadIcon({
  className = '',
  size = 12,
  onClick,
  onKeyDown,
  tabIndex,
  role,
  'aria-label': ariaLabel,
}) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      onClick={onClick}
      onKeyDown={onKeyDown}
      tabIndex={tabIndex}
      role={role}
      aria-label={ariaLabel}
    >
      <path
        d="M0.5 8.16933V8.83333C0.5 9.36377 0.710714 9.87247 1.08579 10.2475C1.46086 10.6226 1.96957 10.8333 2.5 10.8333H9.16667C9.6971 10.8333 10.2058 10.6226 10.5809 10.2475C10.956 9.87247 11.1667 9.36377 11.1667 8.83333V8.16667M5.83333 0.5V7.83333M5.83333 7.83333L8.16667 5.5M5.83333 7.83333L3.5 5.5"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

DownloadIcon.propTypes = {
  className: PropTypes.string,
  size: PropTypes.number,
  onClick: PropTypes.func,
  onKeyDown: PropTypes.func,
  tabIndex: PropTypes.number,
  role: PropTypes.string,
  'aria-label': PropTypes.string,
};

DownloadIcon.defaultProps = {
  className: '',
  size: 12,
  onClick: undefined,
  onKeyDown: undefined,
  tabIndex: undefined,
  role: undefined,
  'aria-label': undefined,
};
